import React, {useMemo, useState} from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

function RowsPerPageComponent(props) {
  const { id, isSelectDisabled } = props;
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage ?? 10);
  const options = useMemo(() => Array.from([5, 10, 25, 50, 100], x => { return { value: x, display: x.toString() } }),[]);

  const changeRowsPerPage = (event) =>{
    const value = event.target.value;
    setRowsPerPage(value);
    props.changeRowsPerPage(value);
  }

  return (
    <div className="table-rows-control">
      <span className="table-rows-control__label">
        <FormattedMessage id="components.layout.table.rowsPerPage.rowsPerPageText"/>
      </span>
      <select
        id={`rows-per-page-input-table-${id}`}
        className="form-control form-control-sm rows-per-page"
        disabled={isSelectDisabled}
        aria-label="RowsPerPage"
        value={rowsPerPage}
        onChange={changeRowsPerPage}
      >
      {
        options.map((option) => (
          <option value={option.value} key={option.value}>
            { option.display }
          </option>
        ))
      }
      </select>
    </div>
  );
}

RowsPerPageComponent.defaultProps = {
  search: () => { }
};

const mapStateToProps = state => ({
  // loading: state.loading.pendingRequests
  isSelectDisabled: state.loading.pendingRequests > 0
});

const RowsPerPage = connect(mapStateToProps)(RowsPerPageComponent);

export { RowsPerPageComponent, RowsPerPage };
